import { brand } from "../../../lib/assets"
import "./CommonAuthLayout.css"

const CommonAuthLayout = ({ children, title, showTitle = true }) => {
  return (
    <div className="common-auth-layout">
      {/* Common Header */}
      <header className="common-auth-header">
        <div className="header-left">
          <span className="brand-name">
            <img src={brand.sohoSocial} alt="SoHo logo" className="soho-logo" />
          </span>
        </div>
        {showTitle && title && (
          <div className="header-center">
            <h1 className="header-title">{title}</h1>
          </div>
        )}
      </header>

      {/* Common Background with Content */}
      <div className="common-auth-content">{children}</div>
    </div>
  )
}

export default CommonAuthLayout
